import SteppedManualInfiniteCarousel from 'components/infinite/SteppedManualInfiniteCarousel';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import Component, { forceArray } from 'navigation/component/Component';
export default class CatalogPush extends Component {
    static slideDuration = 8000;
    totalDuration = 0;
    currentDuration = 0;
    initialized() {
        super.initialized();
        this.totalDuration = this.refs.slides.length * CatalogPush.slideDuration;
        this.refresh();
    }
    getModulesMap() {
        if (this.refs.slides.length > 1) {
            return {
                carousel: ['.catalog-push__slider', SteppedManualInfiniteCarousel]
            };
        }
        else {
            return {};
        }
    }
    bindEvents(add) {
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        if (this.refs.more) {
            this.refs.more.forEach((more, index) => {
                more[method]('click', () => this.onMore(index));
            });
        }
        if (this.refs.less) {
            this.refs.less.forEach((less, index) => {
                less[method]('click', () => this.onLess(index));
            });
        }
        forceArray(this.refs.ctas).forEach(cta => {
            if (cta)
                cta[method]('click', (e) => this.onCTAClick(e));
        });
        if (this?.modules?.carousel) {
            this.modules.carousel[emitterMethod]('progress', this.onProgress);
            this.modules.carousel[emitterMethod]('restructure', this.refresh.bind(this));
        }
    }
    onCTAClick(e) {
        this.emit('click', e);
    }
    onProgress = (progress) => {
        if (this.refs.track)
            this.refs.track.style.transform = `translate3d(0, 0, 0) scaleX(${progress})`;
    };
    onMore(index) {
        const originalLength = this?.modules?.carousel?.modules.infiniteLine.originalItems.length || 0;
        this.refs.body[index].classList.add('hidden');
        this.refs.fullBody[index].classList.remove('hidden');
        this?.refs?.body[originalLength - 1 + index]?.classList?.add('hidden');
        this.refs.fullBody[originalLength - 1 + index]?.classList?.remove('hidden');
    }
    onLess(index) {
        if (this.refs.body[index])
            this.refs.body[index].classList.remove('hidden');
        if (this.refs.fullBody[index])
            this.refs.fullBody[index].classList.add('hidden');
    }
}
